import React from "react";
import Nav from "../Nav";
import "./LandingScreen.css";
import { useSelector } from "react-redux";
import { selectUser } from "../features/userSlice";
import HomeScreen from "./HomeScreen";

const LandingScreen = () => {
  const user = useSelector(selectUser);
  return user ? <HomeScreen /> : (
    <>
      <Nav />
      <div className="landingScreen">
        <div className="landingScreen__banner">
          <div className="landingScreen__banner__details">
            <h1>Unlimited movies, TV shows and more.</h1>
            <p>Watch anywhere. Cancel anytime.</p>
            <p>
              Ready to watch? Enter your email to create or restart your
              membership.
            </p>
            <div className="landingScreen__banner__input">
              <input type="email" name="" id="" placeholder="Email Address" />
              <button>Get Started &gt; </button>
            </div>
          </div>
        </div>
        <div className="landingScreen__items">
            <div className="landingScreen__items item" id="">
                <div className="landingScreen__items item-details">
                    <h1>Enjoy on your TV.</h1>
                    <p>Watch on smart TVs, PlayStation, Xbox, Chromecast, Apple TV, Blu-ray players and more.</p>
                </div>
                <img src="https://assets.nflxext.com/ffe/siteui/acquisition/ourStory/fuji/cards/v2.1/enjoyOnTv/en.png" alt="" />
            </div>
        </div>
      </div>
    </>
  );
};

export default LandingScreen;
